module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAbCAYAAAB836/YAAAAAXNSR0IArs4c6QAAATFJREFUSEvtlrtKA0EUhr8zboKVtaCFIYsIgo2dj6GQFDZeUsTaUgSLfYdYmEXFLpD4EnZ5hBSCFgpiYaXZnRzZeCFsdnUDW+4pz8x8c/jnXEYael8pEV4rugFyuUj1+EwkJMF2b3QheOdIhD2FCvBi4NYavM6+PEVHpKmDO4f5rZAPDA5KcNoS14vz6le6SkDXlFkfWdARiIBxwAa8KjQ6h9KLgBYwPwCBbkvcnSmgrwMxVCNY3CKwKm9hmbUIqLENvXNxtyd9dV9PjINngyQhvnxzJbBD/EzAmq99YJP41RP87yifswHb+gAsp8f3u6JZgY/AUgbg+JX/1bDW1gKYrmah4VibqdIr0ubPCizSJjVtcu6HF9rH5NixZ50puU+9fOfyzD+HIU2UA2Al6efwCTajLBQYMWPIAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/imgV2/titleicon.png
// module id = hT1z
// module chunks = 1